class TestSpecialUa {
  get ua() {
    if (window.navigator && window.navigator.userAgent && window.navigator.userAgent) {
      return window.navigator.userAgent;
    } else {
      return 'unkown';
    }
  }
  isBaidu() {
    if (this.ua.indexOf('baidu') > -1) {
      return true;
    } else {
      return false;
    }
  };

  isOppo() {
    if (/oppo/i.test(this.ua)) {
      return true
    } else {
        return false
    }
  }
}

module.exports = new TestSpecialUa();



// WEBPACK FOOTER //
// ./lib/js/func/ua.js